"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Passive_WatchThemDieEffectHandler = exports.Passive_WatchThemDieEffectArgs = void 0;
const __1 = require("../../..");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class Passive_WatchThemDieEffectArgs {
    constructor(attributes, attributeIncreasePercent) {
        this.attributes = attributes;
        this.attributeIncreasePercent = attributeIncreasePercent;
        this.__type = EffectType_1.EffectType.Passive_WatchThemDie;
        this.__typeName = "Passive_WatchThemDie";
        this.name = "Watch Them Die";
        this.harmful = false;
    }
}
exports.Passive_WatchThemDieEffectArgs = Passive_WatchThemDieEffectArgs;
let Passive_WatchThemDieEffectHandler = class Passive_WatchThemDieEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            attributes: state.args.attributes,
            attributeIncreasePercent: state.args.attributeIncreasePercent
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.EnemyKilled, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_WatchThemDie_OnEnemyKilled", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
Passive_WatchThemDieEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Passive_WatchThemDie)
], Passive_WatchThemDieEffectHandler);
exports.Passive_WatchThemDieEffectHandler = Passive_WatchThemDieEffectHandler;
